import _ from 'lodash';
import { mapGetters } from 'vuex';
import { fileUploadAcceptString } from '../utils/constants';

export default {
  data() {
    return {
      fileList: [],
      currentFieldName: '',
      fileUploadAcceptString,
    };
  },
  methods: {
    beforeUpload(file, q) {
      this.currentFieldName = q.fieldName;
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      return true;
    },
    onExceed() {
      this.$message.error('You have exceeded the amount of files allowed for this question');
    },
    onError(error) {
      console.log('error', error);
      if (error.message) {
        const json = JSON.parse(error.message);
        this.$message.error(json.message || 'There has been an error');
      } else {
        this.$message.error('There has been an error');
      }
    },
    onRemove(file) {
      if (!file.response && !file.name) return;
      const { name } = file.response || file;
      const uploadQuestions = this.registration.additionalQs.filter((q) => q.type === 3);
      const uploadDependentQuestions = this.registration.additionalQs.filter((q) => _.get(q, 'dependentQs.body.type') === 3);
      _.forEach(uploadQuestions,
        (q) => {
          const fieldName = _.camelCase(q.fieldName);
          if ((this.registration.meta[fieldName]?.filter((f) => f.originalName === name) || []).length) {
            this.$set(this.registration.meta, fieldName, this.registration.meta[fieldName].filter((f) => f.originalName !== name));
          }
        });
      _.forEach(uploadDependentQuestions,
        (q) => {
          const fieldName = _.camelCase(q.dependentQs.body.fieldName);
          if ((this.registration.meta[fieldName]?.filter((f) => f.originalName === name) || []).length) {
            this.$set(this.registration.meta, fieldName, this.registration.meta[fieldName].filter((f) => f.originalName !== name));
          }
        });
    },
    // onUploaded(response) {
    //   const { name } = response;
    //   const fieldName = _.camelCase(this.currentFieldName);
    //   const uploads = _.get(this, `registration.meta.${fieldName}`);
    //   this.$set(this.registration.meta, fieldName, uploads.concat({ fileName: name }));
    // },

    async handleChange(file, q) {
      const size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.error('File size is more than 10mb');
        return false;
      }
      try {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const res = await this.$http.post('/assemble/api/v1/portal/files/presigned-url', { fileName: file.name });
        const { url, name, originalName } = res.data.data;
        await fetch(url, {
          method: 'PUT',
          body: file.raw,
          headers: { 'Content-Type': '*/*' },
        });
        const fieldName = _.camelCase(q.fieldName);
        const uploads = _.get(this, `registration.meta.${fieldName}`, []);
        this.$set(this.registration.meta, fieldName, uploads.concat({ fileName: name, originalName }));
      } catch (e) {
        console.log('error', e);
        this.$message.error('There has been an error');
      }
      return this.$store.commit('loading', false);
    },
    verifyUploads(isType3) {
      const mandatory = this.registration.additionalQs?.filter((q) => q.type === 3 && q.required && isType3) || [];
      if (mandatory.length) {
        const invalid = mandatory.filter((q) => {
          const fieldName = _.camelCase(q.fieldName);
          if (this.isUpdateQuestions) {
            return this.regoQsAnswers[fieldName] && this.regoQsAnswers[fieldName].uploaded === false;
          }
          // Add safety check for meta field
          const metaField = this.registration.meta[fieldName];
          return !metaField || !Array.isArray(metaField) || !metaField.length;
        });
        if (invalid.length) {
          // Add safety check for fieldName to prevent path.replace errors
          const invalidFields = invalid
            .filter((f) => f && f.fieldName && typeof f.fieldName === 'string')
            .map((f) => f.fieldName);
          if (invalidFields.length) {
            this.$message.error(`You need to complete the following file upload(s): ${invalidFields.join(', ')}`);
          }
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    accept() {
      return fileUploadAcceptString;
    },
    tempUploadLink() {
      return `${process.env.VUE_APP_API_URL}/assemble/api/v1/portal/files/tmp`;
    },
    ...mapGetters('user', [
      'uploadHeaders',
    ]),
  },
};
